import * as React from 'react';

import useEnterpriseMegaMenuLinks from 'bundles/composable-page-header-enterprise/hooks/useEnterpriseMegaMenuLinks';
import SimplifiedMegaMenuWrapper from 'bundles/megamenu/components/SimplifiedMegaMenuWrapper';
import MegaMenuLinksProvider from 'bundles/megamenu/providers/MegaMenuLinksProvider';

const ExploreMegaMenuGridItem = () => {
  const links = useEnterpriseMegaMenuLinks();

  return (
    <MegaMenuLinksProvider links={links} isEnterprise>
      <div className="rc-ExploreMegaMenuGridItem">
        <SimplifiedMegaMenuWrapper />
      </div>
    </MegaMenuLinksProvider>
  );
};

export default ExploreMegaMenuGridItem;
